import { Breakpoint } from "antd/es/_util/responsiveObserve";

import { rawScreen } from "../styles/dimensions.generated";

import { useWindowSize } from "./useWindowSize";

// Antd 5.x has useBreakpointObserver which would be better suited for this
export function useBelowBreakpoint(breakpoint: Breakpoint): boolean {
    const { width } = useWindowSize();
    return width <= rawScreen[breakpoint];
}
